import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import Test from './Test';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from 'react-toastify';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
    {/* <Test/> */}
    <ToastContainer 
        autoClose={5000}
        draggable={false}
        // You can add more global configuration options here
      />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
